import React, { FC } from "react";
import PrevPageIcon from "../UI/Icons/PrevPageIcon";
import NextPageIcon from "../UI/Icons/NextPageIcon";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  paginationLinks: { url: string | null; label: string; active: boolean }[];
  maxVisiblePages: number;
  onPageChange: (url: string | null) => void;
}

const Pagination: FC<PaginationProps> = ({
  currentPage,
  totalPages,
  paginationLinks,
  maxVisiblePages,
  onPageChange,
}) => {
  const pages = [];
  const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  const prevPageLink =
    paginationLinks &&
    paginationLinks?.find((link) => link.label.includes("Previous"));
  if (prevPageLink?.url) {
    pages.push(
      <button
        key="prev"
        type="button"
        className="btn-theme bg-off-white text-black p-0 w-30px h-30px"
        onClick={() => onPageChange(prevPageLink.url)}
      >
        <PrevPageIcon />
      </button>
    );
  }

  if (startPage > 1) {
    pages.push(
      <button
        key="first"
        type="button"
        className="btn-theme p-0 w-30px h-30px bg-off-white text-black"
        onClick={() => onPageChange(paginationLinks[1]?.url)}
      >
        1
      </button>
    );
    if (startPage > 2) {
      pages.push(<span key="dots-start">...</span>);
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    const pageLink = paginationLinks?.find((link) => link.label === `${i}`);
    pages.push(
      <button
        key={i}
        type="button"
        className={`btn-theme p-0 w-30px h-30px text-black ${
          currentPage === i ? "bg-teal" : "bg-off-white"
        }`}
        // disabled={currentPage === i}
        onClick={() => onPageChange(pageLink?.url ?? null)}
      >
        {i}
      </button>
    );
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pages.push(<span key="dots-end">...</span>);
    }
    pages.push(
      <button
        key="last"
        type="button"
        className="btn-theme p-0 w-30px h-30px bg-off-white text-black"
        onClick={() =>
          onPageChange(paginationLinks[paginationLinks.length - 2]?.url)
        }
      >
        {totalPages}
      </button>
    );
  }

  const nextPageLink =
    paginationLinks &&
    paginationLinks?.find((link) => link.label.includes("Next"));
  if (nextPageLink?.url) {
    pages.push(
      <button
        key="next"
        type="button"
        className="btn-theme bg-off-white text-black p-0 w-30px h-30px"
        onClick={() => onPageChange(nextPageLink.url)}
      >
        <NextPageIcon color="#000" />
      </button>
    );
  }

  return (
    <div className="d-flex gap-5 align-items-center justify-content-end flex-wrap">
      {pages}
    </div>
  );
};

export default Pagination;
